import { render, staticRenderFns } from "./FullSandbox.vue?vue&type=template&id=91cbb448&scoped=true"
import script from "./FullSandbox.vue?vue&type=script&lang=js"
export * from "./FullSandbox.vue?vue&type=script&lang=js"
import style0 from "./FullSandbox.vue?vue&type=style&index=0&id=91cbb448&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91cbb448",
  null
  
)

export default component.exports